import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'types';
import { initialState } from './slice';

const selectDomain = (state: RootState) =>
  state.dealerNurturingAutomationSettingsComponentState || initialState;

export const selectDealerNurturingAutomationSettings = createSelector(
  [selectDomain],
  dealerNurturingAutomationSettingsComponentState =>
    dealerNurturingAutomationSettingsComponentState.dealerNurturingAutomationSettings,
);
